define('modules/home/home.module',["client"],
    function(Prospector){
    Prospector.module("HomeApp", function(HomeApp, Prospector, Backbone, Marionette, $, _){
        HomeApp.startWithParent = false;

        HomeApp.onStart = function(){

            $('.modal').on('hide.bs.modal', $.proxy(function(){
                Prospector.trigger('closingModal');
            }, this));

            window.utils.rawOutput("starting HomeApp");
        };

        HomeApp.onStop = function(){
            window.utils.rawOutput("stopping HomeApp");
        };
    });

    Prospector.module("Routers.HomeApp", function(HomeAppRouter, Prospector, Backbone, Marionette, $, _, snackbar){
        HomeAppRouter.Router = Marionette.AppRouter.extend({
            appRoutes: {
                "dashboard"            : "dashboard"
            }
        });


        var executeAction = function(action, arg){
            Prospector.startSubApp("HomeApp");
            action(arg);
        };

        var API = {
            home: function(criterion){
                window.utils.output("home.module.js", "API.home() runs and calls home.controller.loadHome");
                require(["modules/home/main/home.controller"], function(HomeController){
                    executeAction(HomeController.loadHome, criterion);
                });
            },
            /*showDeleteListModal: function(criterion){
                require(["modules/home/modals/modals.controller"], function(ListController) {
                    ListController.showDeleteList(criterion);
                });
            },*/
            dashboard: function(loadSession){
                window.utils.output("home.module.js", "API.dashboard()called. calls => loadDashBoard in dashboard.controller.");
                var func = $.proxy(function (){
                    require(["modules/home/dashboard/dashboard.controller"], function(DashboardController){
                        window.utils.raygunTrack('dashboard');
                        executeAction(DashboardController.loadDashBoard, loadSession);
                    });
                }, this);

                if(loadSession != null && loadSession != undefined && !loadSession){
                    func();
                } else {
                    Prospector.trigger("authAcc", func, 0);
                }
            }


        };

        Prospector.on("dashboard", function(loadSession){
            Prospector.navigate("dashboard");
            API.dashboard(loadSession);
        });

        Prospector.on("home", function(options){
            API.home(options);
        });


        Prospector.on("showDeleteListModal2", function(options){
            API.showDeleteListModal(options);
        });

        Prospector.on("clearToast", function(){
            require(["snackBar"], function(snackbar){
                if(Prospector.lastSnack != undefined){
                    Prospector.lastSnack.remove();
                }
            });
        });

        Prospector.on("createToast", function(content, options){
            require(["snackBar"], function(snackbar){
                if(Prospector.lastSnack != undefined){
                    Prospector.lastSnack.remove();
                }

                var timeout = 15*1000;
                if(options != undefined && options.timeout != undefined){
                    if(options == null){
                        timeout = undefined;
                    } else {
                        timeout = options.timeout;
                    }
                }

                Prospector.lastSnack =
                    $.snackbar({
                    content: content,
                    style: '',// text of the snackbar
                    timeout: timeout
                });
            });
        });

        Prospector.addInitializer(function(){
            new HomeAppRouter.Router({
                controller: API
            });
        });
    });

    return Prospector.HomeAppRouter;
});
